var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenArrowsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.817,
    height: 45.308
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "green_arrows_up_svg__a",
    x1: 0.5,
    y1: 0.832,
    x2: 0.5,
    y2: -0.107,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b480"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7240"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4795"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2202",
    d: "M22.09 10.745L11.5.156a.533.533 0 00-.754 0L.157 10.745a.533.533 0 00.377.91h5.124a.533.533 0 01.533.533v18.8a.533.533 0 00.533.533h8.8a.533.533 0 00.533-.533v-18.8a.533.533 0 01.533-.533h5.124a.533.533 0 00.376-.91z",
    transform: "translate(17.038)",
    fill: "url(#green_arrows_up_svg__a)",
    opacity: 0.512
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2202",
    d: "M19.782 9.623L10.3.14a.477.477 0 00-.675 0L.141 9.623a.477.477 0 00.338.815h4.588a.477.477 0 01.477.477v16.832a.477.477 0 00.477.477H13.9a.477.477 0 00.477-.477V10.915a.477.477 0 01.477-.477h4.588a.477.477 0 00.34-.815z",
    transform: "translate(0 17.084)",
    fill: "url(#green_arrows_up_svg__a)",
    opacity: 0.512
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4796"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2202",
    d: "M21.908 10.657L11.406.155a.529.529 0 00-.748 0l-10.5 10.5a.529.529 0 00.374.9h5.08a.529.529 0 01.529.529v18.645a.529.529 0 00.529.529h8.725a.529.529 0 00.529-.529V12.088a.529.529 0 01.529-.529h5.082a.529.529 0 00.373-.902z",
    transform: "translate(36.753 11.945)",
    fill: "url(#green_arrows_up_svg__a)",
    opacity: 0.512
  })))));
}

export default __webpack_public_path__ + "static/media/green_arrows_up.df11c8774eb8f2fd870bb7d55ec34558.svg";
export { SvgGreenArrowsUp as ReactComponent };